export const mapBookingFormToApi = (data = {}) => {
  const moment = require("moment")
  const date = new Date(
    `${data?.date} ${data?.hour}:${data?.minute} ${data?.timeType}`
  )
  return {
    booked_seats: !data?.bookedSeats ? 1 : data?.bookedSeats,
    bookingType: null,
    booking_type_id: data?.subCalendar,
    require_paying: data?.paymentType,
    start_date: moment(date).format("YYYY-MM-DD HH:mm:SS"),
    start_date_model: date?.toISOString(),
    start_time_model: date?.toISOString(),
    timezone: data?.timezone,
    user_email: data?.email,
    user_id: data.userId,
    user_name: data?.name,
    vendor_id: data?.vendorId,
    notes: data?.notes,
    phone: data?.phone,
  }
}
